module.exports = __webpack_public_path__ + "img/banner01.1c26eabe.webp";